import { SignUpCompleteUrlKey } from "scmp-app/components/popup-container/sign-up-action-redirect/consts";
export const SanitizedUrlKeys = ["onboard", SignUpCompleteUrlKey];
